<template>
    <div class="player" :class="playClass" id="nativePlayer">
        <video :id="'stream-player-' + sid" @play="onplay" playsinline @loadedmetadata="loadPlayer">
            <source :id="'stream-source-' + sid" :src="source"/>
        </video>
    </div>
</template>

<script>
export default {
    name: 'VideoNative',
    props: {
        source: {
            type: String,
            default: ''
        },
        poster: {
            type: String,
            default: null
        },
        autoplay: {
            type: Boolean,
            default: true
        },
        muted:{
            type: Boolean,
            default: true
        },
        loop:{
            type: Boolean,
            default: false
        },
        showplay: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            sid: Math.floor(Math.random() * 9999),
            playerElm: null,
            playClass: ''
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.playerElm = document.getElementById('stream-player-' + this.sid);
        });
        
    },
    methods: {
        onplay(){
            this.$emit('onplay', this.playerElm);
        },
        play() {
            if(!this.playerElm) {
                this.playerElm = document.getElementById('stream-player-' + this.sid);
                this.playerElm.play();
            }  else {
                this.playerElm.play();
            }
        },
        loadPlayer() {
            if(!this.playerElm) {
                this.playerElm = document.getElementById('stream-player-' + this.sid);
            }
            this.playerElm.poster = this.poster;
            this.playerElm.muted  = this.muted;
            this.playerElm.autoPlay = this.autoplay;
            this.playerElm.loop = this.loop;
            this.playerElm.controls = true;
            this.playerElm.playsinline = true;
            this.playerElm.onplay = (event) => {
                this.playClass = 'playing';
            };
            this.playerElm.onpause = (event) => {
                this.playClass = 'pause';
            };
            this.playerElm.onended = (event) => {
                this.playClass = 'stop';
            };
        },
    },
};
</script>
